// extracted by mini-css-extract-plugin
export default {"wrapper":"Chart_wrapper__+nA5y"};